import { createFileRoute } from '@tanstack/react-router'

import { WalletUsageSection } from '@/modules/account'
import { useIsScreenerEntitled } from '@/modules/tools/bankruptcy'

export const Route = createFileRoute('/_authenticated/credits/usage')({
  component: CreditsUsagePage,
})

function CreditsUsagePage() {
  const isScreenerEntitled = useIsScreenerEntitled()

  return (
    <>
      <WalletUsageSection wallet="pages" />
      {isScreenerEntitled && (
        <WalletUsageSection wallet="screenings" className="border-t pt-8" />
      )}
    </>
  )
}
